/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Command } from './Command';
import {
    CommandFromJSON,
    CommandFromJSONTyped,
    CommandToJSON,
} from './Command';

/**
 * 
 * @export
 * @interface ColumnExport
 */
export interface ColumnExport {
    /**
     * 
     * @type {Command}
     * @memberof ColumnExport
     */
    copyColumnToClipboardCommand?: Command;
}

/**
 * Check if a given object implements the ColumnExport interface.
 */
export function instanceOfColumnExport(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ColumnExportFromJSON(json: any): ColumnExport {
    return ColumnExportFromJSONTyped(json, false);
}

export function ColumnExportFromJSONTyped(json: any, ignoreDiscriminator: boolean): ColumnExport {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'copyColumnToClipboardCommand': !exists(json, 'copyColumnToClipboardCommand') ? undefined : CommandFromJSON(json['copyColumnToClipboardCommand']),
    };
}

export function ColumnExportToJSON(value?: ColumnExport | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'copyColumnToClipboardCommand': CommandToJSON(value.copyColumnToClipboardCommand),
    };
}

